<input type="checkbox" id="toggle-button-checkbox_{{idForControl}}" style="display:none;" [checked]="initial ? 'checked' : ''" (change)="Toggle($event)" />
<label class="toggle-button-switch"
       for="toggle-button-checkbox_{{idForControl}}"></label>
<div class="row-no-margin" style="width:200px;">
  <div class="toggle-button-text">
    <div class="toggle-button-text-on">{{trueText}}</div>
    <div class="toggle-button-text-off">{{falseText}}</div>
  </div>
  <div class="toggle-button-label">
    <label for="toggle-button-checkbox_{{idForControl}}">{{labelText}}</label>
  </div>
</div>
